﻿import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";
/**
 * Custom hook to update the user profile.
 * @param {Function} [onCompleted] - Callback function to be called when the mutation completes successfully.
 * @param {Function} [onError] - Callback function to be called when an error occurs during the mutation.
 * @returns {{updateProfile: Function, loading: boolean}} - The function to update the profile and the loading state.
 */
export function useGeneratePublicToken(
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) {
  const [comGeneratePublicToken, { loading }] = useMutation<any>(
    mutations.generatePublicToken,
    {
      onCompleted: ({ generatePublicToken }) => {
        onCompleted(generatePublicToken?.token);
      },
      onError,
      refetchQueries: ["GetPublicToken"],
    },
  );
  const generatePublicToken = useCallback(() => {
    comGeneratePublicToken().then();
  }, [comGeneratePublicToken]);
  return {
    generatePublicToken,
    loading,
  };
}
